import React from 'react';
import { getTagName, getTagColors } from '../../../../../shared/constants/analyticsConstants/generativeCallReview';
import { TagsContainer, CallTag } from './ApplicationDashboard.styles';
import { SupportedDomain } from '../hooks/useDataModalFilters';

export interface DeduplicatedTagsListProps {
    tags: string[];
    domain: SupportedDomain;
    /** Filter out internal VFY_* tags (default: true) */
    filterInternalTags?: boolean;
}

/**
 * DeduplicatedTagsList - Renders a list of tags with duplicate tags combined
 * 
 * If a tag appears multiple times, it will be shown once with a count in parentheses.
 * For example: "Call During Off Hours (4)" instead of showing 4 separate tags.
 */
const DeduplicatedTagsList: React.FC<DeduplicatedTagsListProps> = ({
    tags,
    domain,
    filterInternalTags = true
}) => {
    // Filter out internal VFY_* tags if enabled
    const visibleTags = filterInternalTags
        ? tags.filter(tag => !tag.startsWith('VFY_'))
        : tags;

    // Count occurrences of each tag
    const tagCounts = visibleTags.reduce((acc, tag) => {
        acc[tag] = (acc[tag] || 0) + 1;
        return acc;
    }, {} as Record<string, number>);

    const uniqueTags = Object.keys(tagCounts);

    return (
        <TagsContainer>
            {uniqueTags.map((tag, idx) => {
                const colors = getTagColors(tag);
                const count = tagCounts[tag];
                return (
                    <CallTag
                        key={idx}
                        style={{
                            backgroundColor: colors.background,
                            color: colors.color,
                            borderColor: colors.border
                        }}
                    >
                        {getTagName(tag, domain)}{count > 1 ? ` (${count})` : ''}
                    </CallTag>
                );
            })}
        </TagsContainer>
    );
};

export default DeduplicatedTagsList;
